import {Chip} from '@dropbox/dig-components/chip';
import type {WorkstreamTimeframeRef} from 'client';

/**
 * A workstream's timeframe name, or "No timeframe" when `showNone`.
 * `highlighted` marks it as matching the timeframe in context (a picker's parent).
 */
export const WorkstreamTimeframeChip = ({
  timeframe,
  showNone = false,
  highlighted = false,
}: {
  timeframe?: WorkstreamTimeframeRef | null;
  showNone?: boolean;
  highlighted?: boolean;
}) => {
  if (!timeframe && !showNone) return null;
  return (
    <Chip
      size="small"
      variant={highlighted ? 'attention' : 'standard'}
      data-testid="workstream-timeframe-chip"
    >
      <Chip.Content>{timeframe?.name ?? 'No timeframe'}</Chip.Content>
    </Chip>
  );
};
